import { Constants, EmptyValue } from '@dx-ui/dx-common';
import { Translate } from 'react-admin';

export const getTaxCategoryDisplay = (
  value: string,
  translate: Translate
): { display: string; tooltip?: string } => {
  switch (value) {
    case Constants.TAX_SCHEME_ID_S:
      return {
        display: translate('dxMessages.invoices.taxCategory.standard'),
      };
    case Constants.TAX_SCHEME_ID_AE:
      return {
        display: translate('dxMessages.invoices.taxCategory.reverse'),
      };
    case Constants.TAX_SCHEME_ID_E:
      return {
        display: translate('dxMessages.invoices.taxCategory.exempt'),
      };
    case Constants.TAX_SCHEME_ID_Z:
      return {
        display: translate('dxMessages.invoices.taxCategory.zeroVat'),
      };
    case Constants.TAX_SCHEME_ID_G:
      return {
        display: translate('dxMessages.invoices.taxCategory.freeExport'),
      };
    case Constants.TAX_SCHEME_ID_O:
      return {
        display: translate('dxMessages.invoices.taxCategory.outsideOfScope'),
      };
    case Constants.TAX_SCHEME_ID_K:
      return {
        display: translate('dxMessages.invoices.taxCategory.EEAIntraCommunity'),
      };
    case Constants.TAX_SCHEME_ID_7:
      return {
        display: value,
      };
    case Constants.TAX_SCHEME_NAME_00_44:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.00_44'),
      };
    case Constants.TAX_SCHEME_NAME_03_SE:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.03_SE'),
      };
    case Constants.TAX_SCHEME_NAME_44:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.44'),
      };
    case Constants.TAX_SCHEME_NAME_45:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.45'),
      };
    case Constants.TAX_SCHEME_NAME_46_GO:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.46_GO'),
      };
    case Constants.TAX_SCHEME_NAME_46_TR:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.46_TR'),
      };
    case Constants.TAX_SCHEME_NAME_47_AS:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_AS'),
      };
    case Constants.TAX_SCHEME_NAME_47_DI:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_DI'),
      };
    case Constants.TAX_SCHEME_NAME_47_EE:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_EE'),
      };
    case Constants.TAX_SCHEME_NAME_47_EI:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_EI'),
      };
    case Constants.TAX_SCHEME_NAME_47_EX:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_EX'),
      };
    case Constants.TAX_SCHEME_NAME_47_SE:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_SE'),
      };
    case Constants.TAX_SCHEME_NAME_47_TO:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.47_TO'),
      };
    case Constants.TAX_SCHEME_NAME_FD:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.FD'),
      };
    case Constants.TAX_SCHEME_NAME_NA:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.NA'),
      };
    case Constants.TAX_SCHEME_NAME_NS:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.NS'),
      };
    case Constants.TAX_SCHEME_NAME_OSS_G:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.OSS_G'),
      };
    case Constants.TAX_SCHEME_NAME_OSS_I:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.OSS_I'),
      };
    case Constants.TAX_SCHEME_NAME_OSS_S:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.OSS_S'),
      };
    case Constants.TAX_SCHEME_NAME_SC:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.SC'),
      };
    case Constants.TAX_SCHEME_NAME_S_01:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.01'),
      };
    case Constants.TAX_SCHEME_NAME_S_02:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.02'),
      };
    case Constants.TAX_SCHEME_NAME_S_03:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.03'),
      };
    case Constants.TAX_SCHEME_NAME_Z_00:
      return {
        display: value,
        tooltip: translate('dxMessages.invoices.taxCategory.00'),
      };
    default:
      return {
        display: translate(`dxMessages.invoices.taxCategory.${value}`, {
          _: value ? value : EmptyValue,
        }),
      };
  }
};
